import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Service = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Service Program */}
        <div className="text-center mb-14">
          <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-indigo-600">
            {t.service.program.label}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 max-w-4xl mx-auto leading-tight">
            {t.service.program.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-24">
          {t.service.program.items.map((item, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-2xl p-8 shadow-sm border border-slate-100"
            >
              <div className="w-10 h-10 rounded-lg bg-indigo-600 text-white flex items-center justify-center font-bold mb-4">
                {index + 1}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Future of Digital Personalities */}
        <div className="text-center mb-14">
          <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-indigo-600">
            {t.service.future.label}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 max-w-4xl mx-auto leading-tight">
            {t.service.future.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto mb-16">
          {t.service.future.cards.map((card, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-indigo-50 to-violet-50 rounded-2xl p-8 border border-indigo-100"
            >
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {card.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        <h3 className="text-center text-2xl font-bold text-slate-900 mb-10">
          {t.service.future.benefitsTitle}
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.service.future.benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-amber-400 text-center"
            >
              <h4 className="text-lg font-bold text-slate-900 mb-3">
                {benefit.title}
              </h4>
              <p className="text-slate-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
